import { Lang } from 'cat-shared/utils'

export default {
  [Lang.EN]: {
    header: 'Profile',
    badge: {
      userSinceInfo: 'Joined {{ timePassed }}',
      emailStatus: {
        confirmed: 'Email confirmed',
        notConfirmed: 'Email not confirmed',
      },
      fullAccount: 'Full account',
    },
    stats: {
      question_one: 'question created',
      question: 'questions created',
      answer_one: 'question answered',
      answer: 'questions answered',
      correctness: 'correctness',
      allAnswer: 'of all questions answered',
      correctAnswers: 'correct answers',
    },
    buttons: {
      goToQuestions: 'See your questions',
    },
    contextMenu: {
      changeAvatar: 'Change avatar',
      updatePersonalDetails: 'Update personal details',
    },
    activity: {
      title: 'Latest activity',
      createdAt: 'Created',
      answeredAt: 'Answered',
      reportedAt: 'Reported',
    },
  },
}
